import { isNil } from 'lodash'
import moment from 'moment-timezone'
import { useCallback, useEffect, useState } from 'react'

import useFetch from 'civic-champs-shared/api/hooks/useFetch'
import { mapEventGeofencingToGeofencing } from 'utils/event'
import { OpportunityResponseWithRecurrenceInfo } from 'Event/interfaces/interfaceCreateEditEvent'
import { decodeOccurrenceId } from 'Event/helpers/encodeOccurrence'

export const useGetEvent = (
  encodedOccurrence?: string,
  populateRecurrenceInfo = true,
  preload = true,
): { event: OpportunityResponseWithRecurrenceInfo | null; loading: boolean; refresh: () => void } => {
  const [done, setDone] = useState(false)
  const [event, setEvent] = useState<OpportunityResponseWithRecurrenceInfo | null>(null)
  const [requestEvent, { called }] = useFetch() as any

  const refresh = useCallback(() => {
    ;(async () => {
      setDone(false)
      const result = await requestEvent({
        url: `/opportunity_instances/${encodedOccurrence}/?populateRecurrenceInfo=${populateRecurrenceInfo}`,
      })
      const { geofencing, ...eventData } = result
      setEvent({
        ...eventData,
        geofencing: mapEventGeofencingToGeofencing(geofencing ?? null),
      })
      setDone(true)
    })()
  }, [encodedOccurrence, populateRecurrenceInfo, requestEvent])

  useEffect(() => {
    // we only want to trigger a preload if the fetch has never been called
    if (preload && !called) {
      refresh()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const { opportunityId: encodedOppId, date: encodedDate } = !isNil(encodedOccurrence)
      ? decodeOccurrenceId(encodedOccurrence)
      : { opportunityId: null, date: null }

    const eventOppId = event?.opportunityId
    const eventDate = !isNil(event)
      ? moment.tz(event.startsAt, event.organization.timeZone as string).format('YYYY-MM-DD')
      : null

    if (encodedOppId != eventOppId || encodedDate != eventDate) {
      refresh()
    }
  }, [refresh, event, encodedOccurrence])

  return {
    event,
    loading: !done,
    refresh,
  }
}
